import Swiper from 'swiper'
import { EffectFade, Autoplay, Navigation, Pagination } from 'swiper/modules'

function customSwiper() {

  const remInPx = parseFloat(getComputedStyle(document.documentElement).fontSize);
  const spaceBetweenRem = 3 * remInPx;

  const swiper = new Swiper('.swiper', {
    modules: [EffectFade, Autoplay, Navigation, Pagination],
    spaceBetween: spaceBetweenRem,
    // centeredSlides: true,
    loop: true,
    autoplay: {
      delay: 3500,
      disableOnInteraction: false
    },
    speed: 750,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    breakpoints: {
      640: {
        slidesPerView: 1.5,
      },
      768: {
        slidesPerView: 2.5,
      },
      1024: {
        slidesPerView: 3,
      }
    }
  })
}

export default customSwiper
